import React from 'react';
import { Rocket, ExternalLink } from 'lucide-react';
import CivicModal from './CivicModal';
import { SongActionModal } from '../lib/actionModalService';

interface DynamicActionModalProps {
  isOpen: boolean;
  onClose: () => void;
  modal: SongActionModal | null;
  onCtaClick?: () => void;
}

export default function DynamicActionModal({
  isOpen,
  onClose,
  modal,
  onCtaClick,
}: DynamicActionModalProps) {
  if (!modal) {
    return (
      <CivicModal
        isOpen={isOpen}
        onClose={onClose}
        title="Take Action"
        icon={Rocket}
        maxWidth="md"
      >
        <div
          className="bg-[#1A1A1A] rounded-xl border text-center py-12"
          style={{
            borderColor: 'rgba(255, 255, 255, 0.08)',
          }}
        >
          <p className="text-[#808080] text-[14px]">
            No action available for this story yet.
          </p>
        </div>
      </CivicModal>
    );
  }

  const handleCtaClick = () => {
    if (modal.cta_type === 'link' && modal.cta_url) {
      window.open(modal.cta_url, '_blank', 'noopener,noreferrer');
    } else if (modal.cta_type === 'action' && onCtaClick) {
      onCtaClick();
    }
    onClose();
  };

  return (
    <CivicModal
      isOpen={isOpen}
      onClose={onClose}
      title={modal.title}
      icon={Rocket}
      maxWidth="md"
    >
      <div
        className="bg-[#1A1A1A] rounded-xl border"
        style={{
          borderColor: 'rgba(255, 255, 255, 0.08)',
          padding: '32px 24px',
        }}
      >
        <div className="mb-6">
          <p
            className="text-[#E0E0E0] whitespace-pre-wrap"
            style={{
              fontSize: '14px',
              lineHeight: '1.65',
            }}
          >
            {modal.body}
          </p>
        </div>

        {modal.cta_type !== 'none' && (
          <div className="pt-4 flex flex-col items-center">
            <button
              onClick={handleCtaClick}
              className="w-full sm:max-w-[420px] flex items-center justify-center gap-2.5 px-8 rounded-full border transition-all duration-200"
              style={{
                height: '48px',
                backgroundColor: 'transparent',
                borderColor: 'rgba(64, 224, 208, 0.40)',
                cursor: 'pointer',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(64, 224, 208, 0.06)';
                e.currentTarget.style.borderColor = 'rgba(64, 224, 208, 0.60)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.borderColor = 'rgba(64, 224, 208, 0.40)';
              }}
            >
              <span
                className="text-[15px] font-medium"
                style={{ color: '#40E0D0', letterSpacing: '0.005em' }}
              >
                {modal.cta_label}
              </span>
              {modal.cta_type === 'link' && (
                <ExternalLink
                  className="w-[16px] h-[16px]"
                  stroke="#40E0D0"
                  strokeWidth={1.5}
                />
              )}
            </button>
          </div>
        )}
      </div>
    </CivicModal>
  );
}
